import {
    STATEMENTS_FAILURE,
    STATEMENTS_LOAD,
    STATEMENTS_SUCCESS,
    STATEMENT_FAILURE,
    STATEMENT_LOAD,
    STATEMENT_SUCCESS
} from './statementsActions';
import { TABLE_UNMOUNT } from '../Table/tableActions';
import {
    get,
    isEqual
} from 'lodash';
import { createSelector } from 'reselect';
import { getEntityByName } from '../appEntities';

export default function reducer(state = {}, action = {}) {
    let  newState;

    switch (action.type) {
        case TABLE_UNMOUNT:
            newState = {
                ...state,
                statements: []
            };

            return isEqual(state, newState) ? state : newState;

        case STATEMENTS_LOAD:
            newState = {
                ...state,
                error: null,
                loading: true,
                statements: []
            };

            return isEqual(state, newState) ? state : newState;

        case STATEMENTS_SUCCESS:
            newState = {
                ...state,
                count: action.count,
                loading: false,
                pages: action.pages,
                statements: action.statements,
                hasMore: action.hasMore,
                offset: action.offset,
                limit: action.limit
            };

            return isEqual(state, newState) ? state : newState;

        case STATEMENTS_FAILURE:
            newState = {
                ...state,
                count: 0,
                error: action.error,
                loading: false,
                pages: 0
            };

            return isEqual(state, newState) ? state : newState;

        case STATEMENT_LOAD:
            newState = {
                ...state,
                statementPdfs: {
                    ...state.statementPdfs,
                    [action.statementId]: {
                        pdfData: null,
                        statementError: null,
                        statementLoading: true
                    }
                }
            };

            return isEqual(state, newState) ? state : newState;

        case STATEMENT_SUCCESS:
            newState = {
                ...state,
                statementPdfs: {
                    ...state.statementPdfs,
                    [action.statementId]: {
                        pdfData: action.statement,
                        statementLoading: false
                    }
                }
            };

            return isEqual(state, newState) ? state : newState;

        case STATEMENT_FAILURE:
            newState = {
                ...state,
                statementPdfs: {
                    ...state.statementPdfs,
                    [action.statementId]: {
                        statementError: action.error,
                        statementLoading: false
                    }
                }
            };

            return isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getStatementsEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'statements')
);

export const getPages = createSelector(
    getStatementsEntity,
    (entity) => get(entity, 'pages')
);

export const getCount = createSelector(
    getStatementsEntity,
    (entity) => get(entity, 'count')
);

export const getIsStatementsLoading = createSelector(
    getStatementsEntity,
    (entity) => get(entity, 'loading')
);

export const getStatements = createSelector(
    getStatementsEntity,
    (entity) => get(entity, 'statements')
);

export const getStatementsError = createSelector(
    getStatementsEntity,
    (entity) => get(entity, 'error')
);

export const getStatementsErrorMessage = createSelector(
    getStatementsError,
    (error) => get(error, 'message')
);

export const getStatementPdfs = createSelector(
    getStatementsEntity,
    (entity) => get(entity, 'statementPdfs')
);

export const getStatementPdfsObject = createSelector(
    getStatementPdfs,
    (state, statementId) => statementId,
    (statementPdf, statementId = '') => get(statementPdf, statementId)
);

export const getStatement = createSelector(
    (state, statementId) => getStatementPdfsObject(state, statementId),
    (statementPdfsObject) => get(statementPdfsObject, 'statement')
);

export const getIsStatementLoading = createSelector(
    (state, statementId) => getStatementPdfsObject(state, statementId),
    (statementPdfsObject) => get(statementPdfsObject, 'statementLoading')
);

export const getStatementError = createSelector(
    (state, statementId) => getStatementPdfsObject(state, statementId),
    (statementPdfsObject) => get(statementPdfsObject, 'statementError')
);

export const getStatementErrorMessage = createSelector(
    (state, statementId) => getStatementError(state, statementId),
    (error) => get(error, 'message')
);

export const getStatementPdfData = createSelector(
    (state, statementId) => getStatementPdfsObject(state, statementId),
    (statementPdfsObject) => get(statementPdfsObject, 'pdfData')
);
